import { Column, Row } from 'src/shared/components/Semantic/all'
import { Button } from 'src/shared/components/ui'
import { Separator } from 'src/shared/components/ui/separator'
import { useLocalization } from 'src/shared/hooks/useLocalization'
import type { BusinessOAuthProvider } from '../consts'

const GoogleMark = () => (
  <svg viewBox="0 0 24 24" className="h-4 w-4" aria-hidden>
    <path
      fill="#4285F4"
      d="M23.49 12.27c0-.79-.07-1.54-.2-2.27H12v4.51h6.48c-.28 1.5-1.13 2.77-2.4 3.62v3h3.88c2.27-2.09 3.53-5.17 3.53-8.86z"
    />
    <path
      fill="#34A853"
      d="M12 24c3.24 0 5.96-1.07 7.95-2.87l-3.88-3c-1.08.72-2.47 1.15-4.07 1.15-3.13 0-5.78-2.11-6.73-4.96H1.27v3.09C3.25 21.3 7.31 24 12 24z"
    />
    <path
      fill="#FBBC05"
      d="M5.27 14.32A7.21 7.21 0 0 1 4.89 12c0-.8.14-1.58.38-2.32V6.59H1.27A11.99 11.99 0 0 0 0 12c0 1.94.46 3.77 1.27 5.41l4-3.09z"
    />
    <path
      fill="#EA4335"
      d="M12 4.75c1.76 0 3.33.61 4.57 1.8l3.43-3.43C17.95 1.19 15.24 0 12 0 7.31 0 3.25 2.7 1.27 6.59l4 3.09C6.22 6.86 8.87 4.75 12 4.75z"
    />
  </svg>
)

const MicrosoftMark = () => (
  <svg viewBox="0 0 24 24" className="h-4 w-4" aria-hidden>
    <path fill="#F25022" d="M1 1h10v10H1z" />
    <path fill="#7FBA00" d="M13 1h10v10H13z" />
    <path fill="#00A4EF" d="M1 13h10v10H1z" />
    <path fill="#FFB900" d="M13 13h10v10H13z" />
  </svg>
)

export const SocialAuthButtons = ({
  loading,
  onProviderClick,
}: {
  loading: boolean
  onProviderClick: (provider: BusinessOAuthProvider) => void
}) => {
  const { t } = useLocalization()

  return (
    <Column className="gap-3">
      <Button
        type="button"
        id="oauth-google"
        variant="secondary"
        size="lg"
        className="w-full"
        disabled={loading}
        onClick={() => onProviderClick('google')}
      >
        <Row className="items-center gap-2">
          <GoogleMark />
          {t('Continue with Google', 'Fortsätt med Google')}
        </Row>
      </Button>

      <Button
        type="button"
        id="oauth-microsoft"
        variant="secondary"
        size="lg"
        className="w-full"
        disabled={loading}
        onClick={() => onProviderClick('azure')}
      >
        <Row className="items-center gap-2">
          <MicrosoftMark />
          {t('Continue with Microsoft', 'Fortsätt med Microsoft')}
        </Row>
      </Button>

      <Row className="items-center gap-3">
        <Separator className="my-0 flex-1" />
        <span className="text-sm text-muted-foreground">
          {t('or', 'eller')}
        </span>
        <Separator className="my-0 flex-1" />
      </Row>
    </Column>
  )
}
